// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"VN-z","upvoteIcon":"WN-z","downvoteIcon":"XN-z","feedbackIcon":"YN-z"};